import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    let event = new Event("checks:search-results-loaded")
    window.dispatchEvent(event)
  }
}
